import React from 'react'
import { Image } from '@shared/components/image'
import { ExternalPaths } from '@shared/menu-items/paths'

import styles from './styles.module.scss'

interface Props {
	ooo?: string
	startYear?: string
	inn?: string
	reestrNumber?: string
	withoutReestr?: boolean
	withOperation?: boolean
	children?: never
}

export const View = ({
	ooo,
	startYear,
	inn,
	reestrNumber,
	withoutReestr,
	withOperation,
}: Props) => {
	return (
		<div className={styles.card}>
			<div className={styles.topWrapper}>
				<div className={styles.image}>
					<Image name='logo-creditclub.png' />
				</div>
				<div className={styles.mkk}>{ooo || 'ООО МКК «Магазин кредитов»'}</div>
				<div className={styles.company}>
					<div className={styles.companyTop}>Начало работы</div>
					<div className={styles.companyContent}>{startYear || '2012'} год</div>
				</div>
			</div>

			<div className={styles.bottomWrapper}>
				<div className={styles.company}>
					<div className={styles.companyTop}>ИНН</div>
					<div className={styles.companyContent}>{inn || '6678014749'}</div>
				</div>
				{withOperation && (
					<p className={styles.operator}>
						Оператор инвестиционных платформ —
						<br />
						<a
							className={styles.operatorLink}
							href='https://www.cbr.ru/finorg/foinfo/?ogrn=1196658084743'
						>
							Банк России
						</a>
					</p>
				)}
				{!withoutReestr && (
					<div className={styles.company}>
						<div className={styles.companyTop}>Номер в реестре Банка России</div>
						<div className={styles.companyContent}>{reestrNumber || '651303455003905'}</div>
					</div>
				)}
			</div>
		</div>
	)
}
